import { QUESTIONNAIRE_STATUS } from '../../../constants';
import {
  FORTA_BLUE,
  FORTA_BROWN,
  FORTA_ORANGE,
  FORTA_PINK,
  FORTA_SUCCESS,
} from '../../../utils/colors';

export const QUESTIONNAIRE_HISTORY_TYPE = {
  ONBOARDING: 'Onboarding',
  INTAKE: 'Intake',
} as const;

export const QUESTIONNAIRE_HISTORY_TYPE_COLORS = {
  [QUESTIONNAIRE_HISTORY_TYPE.ONBOARDING]: FORTA_BROWN,
  [QUESTIONNAIRE_HISTORY_TYPE.INTAKE]: FORTA_PINK,
} as const;

export const QUESTIONNAIRE_HISTORY_STATUS_LABELS = {
  [QUESTIONNAIRE_STATUS.STARTED]: 'Started',
  [QUESTIONNAIRE_STATUS.IN_PROGRESS]: 'In progress',
  [QUESTIONNAIRE_STATUS.COMPLETED]: 'Completed',
} as const;

export const QUESTIONNAIRE_HISTORY_STATUS_COLORS = {
  [QUESTIONNAIRE_STATUS.STARTED]: FORTA_ORANGE,
  [QUESTIONNAIRE_STATUS.IN_PROGRESS]: FORTA_BLUE.light1,
  [QUESTIONNAIRE_STATUS.COMPLETED]: FORTA_SUCCESS,
} as const;

export const QUESTIONNAIRE_HISTORY_CHIP_WIDTH = 110;
export const QUESTIONNAIRE_HISTORY_CHIP_FONT_SIZE = 14;
